'use strict'

class Cars {
    constructor(){
        var options;
		
        $('.menu.desktop.r .menu_cars').addClass('active');
        //$('#autos').fadeOut(function() {
            setTimeout(function() {
                $('.carList#autos').addClass('active');
            }, 2000);             
        //})
        
		if ($(window).width() > 768) {
            options = {
                slideWidth: 960,
                minSlides: 2,
                maxSlides: 3,
                moveSlides: 1,
                pager: false,
                controls: true,
                slideMargin: 30,
                speed: 1200,
                auto: false,
                onSlideBefore: function(e, o, n) {
                    $(e).closest('.bx-wrapper').find('.car.active').addClass('inactive');
                },
                onSlideAfter: function(e, o, n) {
                    $(e).closest('.bx-wrapper').find('.car').removeClass('active').removeClass('inactive');
                    $(e).addClass('active');
                }
            }
        } else {
            options = {
                slideWidth: 300,
                minSlides: 1,
                maxSlides: 2,
                moveSlides: 1,
                pager: false,
                controls: false,
                slideMargin: 0,
                auto: false,
                onSlideBefore: function(e, o, n) {
                    $(e).closest('.bx-wrapper').find('.car.active').addClass('inactive');
                },
                onSlideAfter: function(e, o, n) {
                    $(e).closest('.bx-wrapper').find('.car').removeClass('active').removeClass('inactive');
                    $(e).addClass('active');
                }
            }
        };

        var cars = $('section.models .cars#autos').bxSlider(options);

        $('section.models .types a').on('click', function(e) {
            e.preventDefault();
            var type = $(this).data('type');
            $('section.models .types a').removeClass('active');
            $(this).addClass('active');
            cars.destroySlider();
            $('section.models .cars#' + type).find('.car:first-child').addClass('active');
            cars = $('section.models .cars#' + type).bxSlider(options);
        });
		
		$('section.models .header a').on('click', function(e) {
			e.preventDefault();
			var type = $(this).data('type');
			$('section.models .header li').removeClass('active');
            $(this).closest('li').addClass('active');

            setTimeout(function() {
                navTabActiveLineAnimated();
            }, 100); 

            $('.carList').removeClass('active')
            $('.carList:not(#' + type + ')').find('.undefined').removeClass('undefined').addClass('animated')                        
            $('.carList#' + type).addClass('active');
			/*$('.carList:not(#' + type + ')').fadeOut(function() {
                $('.carList').removeClass('active')
                setTimeout(function() {
                    $('.carList#' + type).fadeIn().addClass('active');
                }, 2000); 
				
			});*/
        });
    }
}

export default Cars;